export default function isPackoutCompatibleKits(projectTypeGUID) {
  return projectTypeGUID === '745aaf98-5483-4e1a-8d7f-3d32f28d4fb4';
}
